module.exports = __webpack_public_path__ + "static/media/image6.8341819a.JPG";